import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import './index.css';
import Routing from './Routing';
import reportWebVitals from './reportWebVitals';
import { store } from './redux/store';
import './pages/Logs/components/styles.css';
import 'react-calendar/dist/Calendar.css';
import './styles/calendar.css';
import { initPageBoot } from 'pages/components/Loader/BootSplash';
import { AppToaster } from 'utils/toast';

initPageBoot();

const rootEl = document.getElementById('root');
if (rootEl) {
  createRoot(rootEl).render(
    <React.StrictMode>
      <Provider store={store}>
        <AppToaster />
        <Routing />
      </Provider>
    </React.StrictMode>,
  );
}

reportWebVitals();
